package com.evoapps.evoshift.data.dto.owner

import kotlinx.serialization.Serializable

/** SH-131: owners/{uid}/shared_costs/{id}, written by functions/sharedCosts.js only. */
@Serializable
data class SharedCostDto(
    val id: String = "",
    val name: String = "",
    val amount: Double = 0.0,
    val currency: String = "PLN",
    /** ONE_OFF, MONTHLY, YEARLY. */
    val frequency: String = "MONTHLY",
    val date: String? = null,
    val startMonth: String? = null,
    val endMonth: String? = null,
    val allocation: SharedCostAllocationDto = SharedCostAllocationDto()
)

@Serializable
data class SharedCostAllocationDto(
    /** PERCENTAGES, FIXED_AMOUNTS, PROPORTIONAL. */
    val method: String = "PROPORTIONAL",
    /** NET_SALES, INCOME, LABOUR_COST, EQUAL (PROPORTIONAL only). */
    val basis: String? = null,
    val workplaceIds: List<String> = emptyList(),
    val shares: Map<String, Double> = emptyMap()
)
